import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Registro del restaurante',
  description: 'Paso {{activeStep}} de {{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Información básica',
    [Step.BusinessDetails]: 'Detalles del negocio',
  },
  form: {
    name: {
      label: 'Nombre del restaurante',
      placeholder: 'Ingrese el nombre del restaurante',
    },
    timezone: {
      label: 'Zona horaria',
      placeholder: 'Buscar una ciudad o zona horaria',
      inference_failed: 'No pudimos determinar la zona horaria de esta dirección — por favor selecciónela.',
    },
    google_place: {
      label: 'Lugar de Google seleccionado: {{name}}',
    },
    is_franchise: {
      label: 'El restaurante forma parte de una marca',
    },
    sync_lieferando_brand: {
      label: 'Obtener detalles de marca (logo, color principal) de Lieferando',
    },
    import_menu: {
      label: 'Importar menú',
    },
    lieferando_url: {
      label: 'URL de Lieferando',
      placeholder: 'URL del restaurante en Lieferando',
    },
    other_platforms: {
      label: 'Plataformas de entrega actuales',
      description: 'Seleccione todas las plataformas donde está listado actualmente',
    },
    pos_system: {
      label: 'Sistema POS actual',
      placeholder: 'Seleccione su sistema POS',
      options: {
        [PosSystems.Other]: 'Otro',
      },
    },
    delivery_mode: {
      label: 'Modo de entrega',
      placeholder: 'Seleccionar modo de entrega',
      options: {
        [DeliveryMode.Internal]: 'Interno (conductores propios)',
        [DeliveryMode.External]: 'Externo (terceros)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Ventas mensuales de entrega',
      description: 'Ventas totales en todas las plataformas de entrega',
      placeholder: 'Seleccionar rango de ventas',
      options: {
        other: 'Otro',
      },
      other: {
        placeholder: 'Ingrese el monto de ventas',
      },
    },
    lead_source: {
      label: 'Fuente del lead',
      description: '¿Cómo nos conoció?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Contacto de representante de desarrollo de ventas',
        },
        [LeadSources.Inbound]: {
          title: 'Inbound',
          description: 'Llegó a través del sitio web o marketing',
        },
        [LeadSources.Referral]: {
          title: 'Referido - Restaurante existente',
          description: 'Referido por uno de nuestros restaurantes asociados',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Autogenerado - Frío',
          description: 'Encontrado mediante contacto en frío o prospección',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Autogenerado - Referido',
          description: 'Red personal o conexión',
        },
        [LeadSources.Tipster]: {
          title: 'Informador',
          description: 'Foodamigos paga a la persona/empresa X una comisión por la recomendación',
        },
      },
    },
    sdr: {
      description: 'Seleccione el SDR responsable de obtener este lead',
    },
    has_instagram_profile: {
      label: 'Perfil de Instagram',
      description: '¿Su restaurante tiene un perfil de Instagram?',
      options: {
        true: 'Sí',
        false: 'No',
      },
    },
  },
  buttons: {
    back: 'Atrás',
    next: 'Siguiente',
    complete_registration: 'Completar registro',
  },
  basic_information: {
    title: 'Información básica',
    description: 'Ingrese los datos básicos y la información de contacto del restaurante',
  },
  additional_options: {
    title: 'Opciones adicionales',
    description: 'Configure ajustes adicionales para este restaurante',
  },
  restaurant_type: {
    title: 'Tipo de restaurante y modelo de servicio',
    description: 'Elija el formato que mejor describe el estilo de servicio de este restaurante',
  },
  cuisine_type: {
    title: 'Categorías de comida y tipos de cocina',
    description: 'Seleccione todas las categorías de comida y tipos de cocina aplicables',
    placeholder: 'Buscar tipos de cocina',
  },
  business_details: {
    title: 'Detalles del negocio',
    description: 'Ayúdenos a entender sus operaciones actuales',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Restaurante de servicio completo',
      description: 'Comedor con servicio en mesa',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Fast Casual',
      description: 'Pedido en mostrador/app, mayor calidad y personalización que QSR, asientos opcionales',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Servicio rápido (QSR) / Para llevar',
      description: 'Servicio en mostrador rápido; principalmente para llevar',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Café y panadería',
      description: 'Café, pastelería, comidas ligeras, desayuno/brunch',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Postres y helados',
      description: 'Conceptos centrados en dulces',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Bebidas y bar',
      description: 'Locales centrados en bebidas; comida opcional; entrega de alcohol sujeta a normas locales',
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Solo entrega / Cocina fantasma',
      description: 'Sin local físico; marcas virtuales y cocinas en la nube',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Hamburguesas',
    [CuisineTypes.ChickenFried]: 'Pollo frito',
    [CuisineTypes.Wings]: 'Alitas',
    [CuisineTypes.KebabDoner]: 'Kebab/Döner',
    [CuisineTypes.Sandwiches]: 'Sándwiches',
    [CuisineTypes.Wraps]: 'Wraps',
    [CuisineTypes.Salads]: 'Ensaladas',
    [CuisineTypes.Healthy]: 'Saludable',
    [CuisineTypes.Bowls]: 'Bowls',
    [CuisineTypes.Vegan]: 'Vegano',
    [CuisineTypes.Vegetarian]: 'Vegetariano',
    [CuisineTypes.GlutenFree]: 'Sin gluten',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Japonesa',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Coreana',
    [CuisineTypes.KoreanFriedChicken]: 'Pollo frito coreano',
    [CuisineTypes.Chinese]: 'China',
    [CuisineTypes.Sichuan]: 'Sichuan',
    [CuisineTypes.CantoneseDimSum]: 'Cantonés/Dim Sum',
    [CuisineTypes.Thai]: 'Tailandesa',
    [CuisineTypes.Vietnamese]: 'Vietnamita',
    [CuisineTypes.Malaysian]: 'Malaya',
    [CuisineTypes.Indonesian]: 'Indonesia',
    [CuisineTypes.Filipino]: 'Filipina',
    [CuisineTypes.Poke]: 'Poke',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Dumplings/Gyoza/Bao',

    [CuisineTypes.Indian]: 'India',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Pakistaní',
    [CuisineTypes.SriLankan]: 'Sri Lanka',
    [CuisineTypes.Nepalese]: 'Nepalés',

    [CuisineTypes.Turkish]: 'Turco',
    [CuisineTypes.Lebanese]: 'Libanés',
    [CuisineTypes.Syrian]: 'Sirio',
    [CuisineTypes.Israeli]: 'Israelí',
    [CuisineTypes.Egyptian]: 'Egipcio',
    [CuisineTypes.PersianIranian]: 'Persa/Iraní',
    [CuisineTypes.Iraqi]: 'Iraquí',
    [CuisineTypes.Afghan]: 'Afgano',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Parrilla',
    [CuisineTypes.Greek]: 'Griego',
    [CuisineTypes.Mediterranean]: 'Mediterráneo',

    [CuisineTypes.Italian]: 'Italiano',
    [CuisineTypes.Pasta]: 'Pasta',
    [CuisineTypes.French]: 'Francés',
    [CuisineTypes.SpanishTapas]: 'Español/Tapas',
    [CuisineTypes.Portuguese]: 'Portugués',
    [CuisineTypes.German]: 'Alemán',
    [CuisineTypes.Austrian]: 'Austríaco',
    [CuisineTypes.Balkan]: 'Balcánico',
    [CuisineTypes.Hungarian]: 'Húngaro',
    [CuisineTypes.Polish]: 'Polaco',
    [CuisineTypes.Czech]: 'Checo',
    [CuisineTypes.Georgian]: 'Georgiano',

    [CuisineTypes.Mexican]: 'Mexicano',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Peruano',
    [CuisineTypes.Brazilian]: 'Brasileño',
    [CuisineTypes.Argentinian]: 'Argentino',
    [CuisineTypes.Caribbean]: 'Caribeño',
    [CuisineTypes.BBQAmerican]: 'BBQ/Americano',
    [CuisineTypes.Steakhouse]: 'Steakhouse',
    [CuisineTypes.AmericanGeneral]: 'Americano (General)',
    [CuisineTypes.HotDogs]: 'Hot Dogs',

    [CuisineTypes.Seafood]: 'Mariscos',
    [CuisineTypes.FishAndChips]: 'Fish and Chips',
    [CuisineTypes.SteamedFish]: 'Pescado al Vapor',

    [CuisineTypes.BreakfastBrunch]: 'Desayuno/Brunch',
    [CuisineTypes.Bagels]: 'Bagels',
    [CuisineTypes.Bakery]: 'Panadería',
    [CuisineTypes.PastryDessert]: 'Pastelería/Postre',
    [CuisineTypes.WafflesCrepes]: 'Gofres/Crepes',
    [CuisineTypes.IceCreamGelato]: 'Helado/Gelato',
    [CuisineTypes.Donuts]: 'Donuts',
    [CuisineTypes.Cakes]: 'Tartas',

    [CuisineTypes.CoffeeCafe]: 'Café',
    [CuisineTypes.BubbleTea]: 'Bubble Tea',
    [CuisineTypes.JuiceSmoothies]: 'Zumos/Batidos',
    [CuisineTypes.Milkshakes]: 'Milkshakes',
    [CuisineTypes.BarPub]: 'Bar/Pub',
    [CuisineTypes.WineBar]: 'Bar de Vinos',
    [CuisineTypes.Cocktails]: 'Cócteles',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/Mezze/Raciones',
    [CuisineTypes.Noodles]: 'Fideos',
    [CuisineTypes.Soup]: 'Sopa',
    [CuisineTypes.Schnitzel]: 'Schnitzel',
    [CuisineTypes.SoulFood]: 'Soul Food',
    [CuisineTypes.ComfortFood]: 'Comfort Food',
    [CuisineTypes.StreetFood]: 'Comida Callejera',
    [CuisineTypes.OrganicBio]: 'Orgánico/Bio',
    [CuisineTypes.KidsMenu]: 'Menú Infantil',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Top/General',
    [CuisineCategories.AsianPacific]: 'Asiático/Pacífico',
    [CuisineCategories.SouthAsian]: 'Asia del Sur',
    [CuisineCategories.MiddleEastMediterranean]: 'Oriente Medio/Mediterráneo',
    [CuisineCategories.Europe]: 'Europa',
    [CuisineCategories.Americas]: 'Américas',
    [CuisineCategories.SeafoodSpecialty]: 'Especialidad Mariscos',
    [CuisineCategories.BreakfastBakerySweets]: 'Desayuno/Panadería/Dulces',
    [CuisineCategories.BeverageLed]: 'Bebidas',
    [CuisineCategories.OtherConcepts]: 'Otros Conceptos',
  },
};
